import { authReq } from '@/utils/http'

// OpUser related
const getOpUsers = (data) => {
  return authReq.get('/api/v1/op_user', {
    page: data.page,
    'page_size': data.pageSize
  })
}

const addOpUser = (data) => {
  return authReq.post('/api/v1/op_user', {
    username: data.username,
    password: data.password,
    'oper_pwd': data.password,
    alias: data.alias,
    'is_admin': data.isAdmin,
    'role_id': data.roleId,
    'agent_id_list': data.agentIdList
  })
}

const updateOpUser = (data) => {
  return authReq.put(`/api/v1/op_user/${data.userId}`, {
    username: data.username,
    password: data.password,
    'oper_pwd': data.password,
    alias: data.isSubUser,
    'is_admin': data.isAdmin,
    'role_id': data.roleId,
    'agent_id_list': data.agentIdList
  })
}

const delOpUser = (data) => {
  return authReq.delete(`/api/v1/op_user/${data.userId}`)
}

// OpRole related
const getOpRoles = (data) => {
  return authReq.get('/api/v1/op_role', {
    page: data.page,
    'page_size': data.pageSize
  })
}

const addOpRole = (data) => {
  return authReq.post('/api/v1/op_role', {
    name: data.name,
    'resource_id_list': data.resourceIdList,
    remark: data.remark
  })
}

const updateOpRole = (data) => {
  return authReq.put(`/api/v1/op_role/${data.roleId}`, {
    name: data.name,
    'resource_id_list': data.resourceIdList,
    remark: data.remark
  })
}

const delOpRole = (data) => {
  return authReq.delete(`/api/v1/op_role/${data.roleId}`)
}

// Resource related
const getOpResources = (data) => {
  return authReq.get('/api/v1/op_resource', {
    page: data.page,
    'page_size': data.pageSize
  })
}

export default {
  getOpUsers,
  addOpUser,
  updateOpUser,
  delOpUser,

  getOpRoles,
  addOpRole,
  updateOpRole,
  delOpRole,

  getOpResources
}



// WEBPACK FOOTER //
// ./src/api/aclApi.js